export default __webpack_public_path__ + "static/media/skoljoggen.96e4150d.jpeg";